<template>
  <div class="panel panel-default panel-dashboard">
    <div class="panel-heading">
      <h5>
        Index
      </h5>
    </div>

    <loading-spinner v-if="loading" :style="loadingSpinnerStyle"></loading-spinner>

    <div v-else class="panel-body text-center">
      <index-number :value="number" style="font-size: 48px"></index-number>

      <br>

      <span style="font-size: 18px">
                &nbsp;
            </span>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import IndexNumber from '@/components/Numbers/IndexNumber'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import SaveHeight from '@/mixins/SaveHeight'

export default {
  components: {IndexNumber, LoadingSpinner},

  mixins: [SaveHeight],

  props: ['year', 'timeBasedChannel', 'targetMetric', 'user'],

  data() {
    return {
      loading: true,
      number: null
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    year() {
      this.load()
    },

    targetMetric() {
      this.load()
    },

    timeBasedChannel() {
      this.load()
    },

    user() {
      this.load()
    }
  },

  computed: {
    filters() {
      return [
        {dimension: 'publish_year', operator: '=', value: this.year},
        {dimension: 'time_based_channel_id', operator: '=', value: this.timeBasedChannel.id}
      ]
    },

    filtersWithUser() {
      if (!this.user) {
        return this.filters
      }

      return this.filters.concat({dimension: 'user_id', operator: '=', value: this.user})
    }
  },

  methods: {
    load() {
      this.saveHeight()

      this.loading = true

      Promise.all([
        http.post('/api/v1/reports/new-analytics', {
          metrics: [
            {name: 'time_ad_value_after_costs'},
          ],
          filters: this.filtersWithUser
        }),
        http.post('/api/v1/reports/new-analytics', {
          metrics: [
            {name: this.targetMetric},
          ],
          filters: this.filters
        })
      ]).then(responses => {
        this.number = responses[1].data.data[0][this.targetMetric] ? responses[0].data.data[0].time_ad_value_after_costs / responses[1].data.data[0][this.targetMetric] * 100 : null

        this.loading = false
      })
    }
  }
}
</script>
